import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Button } from 'primereact/button';
import { Tag } from 'primereact/tag';
import { InputText } from 'primereact/inputtext';
import CBSpinnerFloating from '../../shared/CBSpinnerFloating';
import {
  fetchChainCustomerMappings as _fetchChainCustomerMappings,
  discoverCustomerMappings as _discoverCustomerMappings,
  discoverSingleCustomerMapping as _discoverSingleCustomerMapping,
  updateCustomerMapping as _updateCustomerMapping,
} from '../../../actions/chainActions';
import { T, cardStyle, inputStyle } from './chainSettingsV2Styles';

var STATUS_SEVERITY = {
  active: 'success',
  manual: 'info',
  not_found: 'warning',
  error: 'danger',
  created: 'success',
};

class ChainCustomerMappingsV2 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editingId: null,
      editValue: '',
    };
  }

  componentDidMount() {
    if (this.props.careServiceId) {
      this.props.fetchChainCustomerMappings(this.props.careServiceId);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.careServiceId && this.props.careServiceId !== prevProps.careServiceId) {
      this.props.fetchChainCustomerMappings(this.props.careServiceId);
    }
  }

  handleDiscoverAll = function () {
    this.props.discoverCustomerMappings(this.props.careServiceId);
  }.bind(this);

  handleDiscoverSingle = function (membershipId) {
    this.props.discoverSingleCustomerMapping(this.props.careServiceId, membershipId);
  }.bind(this);

  startEdit = function (mapping) {
    this.setState({
      editingId: mapping.id,
      editValue: mapping.autofutur_customer_number ? String(mapping.autofutur_customer_number) : '',
    });
  }.bind(this);

  cancelEdit = function () {
    this.setState({ editingId: null, editValue: '' });
  }.bind(this);

  saveEdit = function (mappingId) {
    var value = parseInt(this.state.editValue, 10);
    if (!isNaN(value)) {
      this.props.updateCustomerMapping(mappingId, { autofutur_customer_number: value });
    }
    this.setState({ editingId: null, editValue: '' });
  }.bind(this);

  render() {
    var t = this.props.t;
    var mappings = this.props.chainCustomerMappings;
    var mappingsStatus = this.props.chainCustomerMappingsStatus;
    var isLoading = mappingsStatus && mappingsStatus.loading;
    var editingId = this.state.editingId;
    var editValue = this.state.editValue;

    return (
      <div style={{ marginTop: 16 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
          <h4 style={{ color: T.textPrimary, fontSize: 14, fontWeight: 600, margin: 0 }}>
            {t('customerMappings')}
          </h4>
          <Button
            onClick={this.handleDiscoverAll}
            label={t('discoverAll')}
            icon="pi pi-search"
            className="p-button-outlined p-button-sm"
            disabled={isLoading}
            style={{ borderColor: T.accent, color: T.accent, fontSize: 12 }}
          />
        </div>

        {isLoading && <CBSpinnerFloating color={T.accent} />}

        {mappings && mappings.length > 0 && (
          <div style={{ borderRadius: 6, overflow: 'hidden', border: '1px solid ' + T.border }}>
            {mappings.map(function (mapping) {
              var workshopName = mapping.workshop_name || (mapping.membership_workshop_name) || '-';
              var statusLabel = t('mappingStatus_' + mapping.sync_status) || mapping.sync_status;
              var severity = STATUS_SEVERITY[mapping.sync_status] || 'info';

              return (
                <div
                  key={mapping.id}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 12,
                    padding: '10px 14px',
                    borderBottom: '1px solid ' + T.borderLight,
                    fontSize: 13,
                  }}
                >
                  <div style={{ flex: 2, color: T.textPrimary, fontWeight: 500 }}>
                    {workshopName}
                  </div>
                  <div style={{ flex: 1, color: T.textSecondary }}>
                    {editingId === mapping.id ? (
                      <div style={{ display: 'flex', gap: 4 }}>
                        <InputText
                          value={editValue}
                          onChange={function (e) { this.setState({ editValue: e.target.value }); }.bind(this)}
                          style={{ ...inputStyle, height: 30, fontSize: 12, width: 80 }}
                          onKeyDown={function (e) {
                            if (e.key === 'Enter') { this.saveEdit(mapping.id); }
                            if (e.key === 'Escape') { this.cancelEdit(); }
                          }.bind(this)}
                        />
                        <Button
                          icon="pi pi-check"
                          className="p-button-text p-button-sm"
                          onClick={function () { this.saveEdit(mapping.id); }.bind(this)}
                          style={{ color: '#2ecc71', width: 28, height: 28 }}
                        />
                        <Button
                          icon="pi pi-times"
                          className="p-button-text p-button-sm"
                          onClick={this.cancelEdit}
                          style={{ color: '#e74c3c', width: 28, height: 28 }}
                        />
                      </div>
                    ) : (
                      mapping.autofutur_customer_number || '\u2014'
                    )}
                  </div>
                  <div style={{ flex: 1 }}>
                    <Tag severity={severity} value={statusLabel} style={{ fontSize: 11 }} />
                  </div>
                  <div style={{ display: 'flex', gap: 4 }}>
                    <Button
                      icon="pi pi-refresh"
                      className="p-button-text p-button-sm"
                      onClick={function () { this.handleDiscoverSingle(mapping.membership); }.bind(this)}
                      style={{ color: T.accent, width: 28, height: 28 }}
                      tooltip={t('discoverSingle')}
                    />
                    {editingId !== mapping.id && (
                      <Button
                        icon="pi pi-pencil"
                        className="p-button-text p-button-sm"
                        onClick={function () { this.startEdit(mapping); }.bind(this)}
                        style={{ color: T.textMuted, width: 28, height: 28 }}
                        tooltip={t('enterManually')}
                      />
                    )}
                  </div>
                </div>
              );
            }.bind(this))}
          </div>
        )}

        {mappings && mappings.length === 0 && !isLoading && (
          <p style={{ color: T.textMuted, fontSize: 12, fontStyle: 'italic' }}>
            {t('noCustomerMappings')}
          </p>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    chainCustomerMappings: state.chain.chainCustomerMappings,
    chainCustomerMappingsStatus: state.chain.chainCustomerMappingsStatus,
  };
}

export default connect(
  mapStateToProps,
  {
    fetchChainCustomerMappings: _fetchChainCustomerMappings,
    discoverCustomerMappings: _discoverCustomerMappings,
    discoverSingleCustomerMapping: _discoverSingleCustomerMapping,
    updateCustomerMapping: _updateCustomerMapping,
  },
)(translate('ChainSettingsView')(ChainCustomerMappingsV2));
